export class CreateDistrictResponseEntity {
  success?: boolean
  overlappedAreas?: Array<Array<{ longitude?: number; latitude?: number }>> | null
}
